export default __webpack_public_path__ + "static/media/ic_language24.ada157f6.svg";